// @ts-nocheck

import { createSelector } from 'reselect';

import { selectEntitiesMatchesEntity } from '../../../selectors/entities/matches/entitiesMatchesPrimary.selector';

const getUserConnected = (state) => state.user.connected;
const getUserBankroll = (state) => state.user.balance;
const getUserRealMoney = (state) => state.user.realMoney;

const getMatchSportId = createSelector([selectEntitiesMatchesEntity], (match) => (match && match.sportId) || null);

const getMatchGameScore = createSelector([selectEntitiesMatchesEntity], (match) => (match && match.gameScore) || null);

const getMatchPeriod = createSelector([selectEntitiesMatchesEntity], (match) => (match && match.period) || null);

const getMatchSetScores = createSelector([selectEntitiesMatchesEntity], (match) => (match && match.setScores) || null);

export const panelSelector = createSelector(
  [
    getUserConnected,
    getUserBankroll,
    getUserRealMoney,
    getMatchSportId,
    getMatchGameScore,
    getMatchPeriod,
    getMatchSetScores,
  ],
  (isUserConnected, userBankroll, isUserRealMoney, sportId, gameScore, period, setScores) => ({
    isUserConnected,
    userBankroll,
    isUserRealMoney,
    sportId,
    gameScore,
    period,
    setScores,
  }),
);
